module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/common/categories/prostate-136f83584f5c36ed833736d5c954a6b2.png";